import { Component, OnInit, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { ShellComponent } from '../../ui/shell.component';
import { AdminEventScreen } from './admin-event-screen';

@Component({
  selector: 'app-admin-event-payout-form',
  standalone: true,
  imports: [FormsModule, ShellComponent],
  templateUrl: './admin-event-payout-form.component.html',
})
export class AdminEventPayoutFormComponent extends AdminEventScreen implements OnInit {
  private router = inject(Router);
  place: number | null = 1;
  amount = 0;
  description = '';
  userId: number | null = null;
  fieldErrors: Record<string, string> = {};

  async ngOnInit(): Promise<void> {
    await this.load();
  }

  override get backTo(): unknown[] {
    return ['/admin/events', this.eventId, 'payouts'];
  }

  async save(): Promise<void> {
    this.fieldErrors = {};
    if (Number(this.amount) <= 0) this.fieldErrors['amount'] = 'Enter an amount above zero';
    if (Object.keys(this.fieldErrors).length > 0) return;

    this.error = '';
    this.busy = true;
    try {
      await this.api.put('payout', {
        eventId: this.eventId,
        place: this.place,
        amount: Number(this.amount),
        description: this.description,
        userId: this.userId,
      });
      await this.router.navigate(this.backTo);
    } catch (error: unknown) {
      this.error = error instanceof Error ? error.message : 'Could not save the payout';
    } finally {
      this.busy = false;
    }
  }
}
